import { render } from "./Entrynovipinfo.vue?vue&type=template&id=d12d8646&scoped=true"
import script from "./Entrynovipinfo.vue?vue&type=script&lang=js"
export * from "./Entrynovipinfo.vue?vue&type=script&lang=js"

import "./Entrynovipinfo.vue?vue&type=style&index=0&id=d12d8646&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d12d8646"]])

export default __exports__